import store from '@/store'
import _ from 'lodash'

const { VUE_APP_ENABLE_LLMP_390_PLACE_ORDER } = process.env
const enablePlaceOrder = VUE_APP_ENABLE_LLMP_390_PLACE_ORDER === 'true'

const homeRoute = {
	path: '/',
	name: 'Home',
	meta: { authRequired: true },
	redirect: { name: 'Deliveries' }
}

// auth related routes
const authRoutes = [
	{
		path: '/login',
		name: 'login',
		component: () => lazyLoadView(import('@/views/Login')),
		meta: {
			beforeResolve(_, __, next) {
				// If the user is already logged in
				if (store.getters['auth/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'Home' })
				} else {
					// Continue to the login page
					next()
				}
			}
		}
	},
	{
		// path: '/verification/:code?', // Not used, use query params instead..
		path: '/verification',
		name: 'verification',
		component: () => lazyLoadView(import('@/views/Verification')),
		meta: {
			beforeResolve(_, __, next) {
				// If the user is already logged in
				if (store.getters['auth/loggedIn']) {
					// Redirect to the home page instead
					next({ name: 'Home' })
				} else {
					// Continue to the verification page
					next()
				}
			}
		}
	},
	{
		path: '/logout',
		name: 'logout',
		meta: {
			authRequired: true,
			beforeResolve(_, routeFrom, next) {
				store.dispatch('auth/logOut')
				const authRequiredOnPreviousRoute = routeFrom.matched.some(
					route => route.meta.authRequired
				)
				// Navigate to login page, or previous page if it does not require auth
				next(
					authRequiredOnPreviousRoute
						? { name: 'login' }
						: { ...routeFrom }
				)
			}
		}
	}
]

// error pages
const errorPagesRoutes = [
	{
		path: '/404',
		name: '404',
		component: require('@/views/Error404').default,
		props: true
	},
	{
		path: '*',
		redirect: '404'
	}
]

// main pages routes
const mainRoutes = [
	{
		path: '/deliveries/:clientRef?',
		name: 'Deliveries',
		header: '',
		icon: 'mdi mdi-clipboard-check-outline',
		meta: { authRequired: true },
		component: () => lazyLoadView(import('@/views/Home')),
		props: () => ({ user: store.state.auth.currentUser })
	},
	{
		path: '/place_order',
		name: 'Place Order',
		icon: 'mdi mdi-package-variant',
		badge: enablePlaceOrder
			? null
			: {
					text: 'Soon',
					variant: 'secondary'
			  },
		disabled: !enablePlaceOrder,
		meta: {
			authRequired: true,
			beforeResolve(_, __, next) {
				if (!enablePlaceOrder) {
					next({ name: 'Home' })
				} else {
					next()
				}
			}
		},
		component: () => import('@/views/PlaceOrder'),
		props: () => ({ user: store.state.auth.currentUser })
	},
	{
		path: '/reports',
		name: 'Reports',
		icon: 'mdi mdi-package-variant',
		meta: { authRequired: true },
		component: () => lazyLoadView(import('@/views/Reports')),
		props: () => ({ user: store.state.auth.currentUser })
	}
	// {
	// 	path: '/orders',
	// 	name: 'Orders',
	// 	header: '',
	// 	icon: 'mdi mdi-package-variant-closed',
	// 	meta: { authRequired: true },
	// 	component: () => lazyLoadView(import('@/views/Order')),
	// 	props: () => ({ user: store.state.auth.currentUser }),
	// },
	// {
	// 	path: '/settings',
	// 	name: 'Settings',
	// 	icon: 'mdi mdi-settings-outline',
	// 	badge: {
	// 		text: 'Soon',
	// 		variant: 'secondary',
	// 	},
	// 	disabled: true,
	// },
]

const currentUserClientId = _.get(store, 'state.auth.currentUser.clientId', '')
if (currentUserClientId) {
	mainRoutes.push({
		path: '/settings',
		name: 'Settings',
		header: '',
		icon: 'mdi mdi-settings-outline',
		meta: { authRequired: true },
		component: () => lazyLoadView(import('@/views/Settings')),
		props: () => ({ user: store.state.auth.currentUser })
	})
}

const authProtectedRoutes = [...mainRoutes]

const allRoutes = [
	homeRoute,
	...authRoutes,
	...authProtectedRoutes,
	...errorPagesRoutes
]

export { allRoutes, authProtectedRoutes }

function lazyLoadView(AsyncView) {
	const AsyncHandler = () => ({
		component: AsyncView,
		loading: require('@/views/Loading').default
	})

	return Promise.resolve({
		functional: true,
		render(h, { data, children }) {
			return h(AsyncHandler, data, children)
		}
	})
}
